module.exports = __webpack_public_path__ + "fonts/97252acf-16d3-480c-8269-89ea815e4179.ae35beea.woff";